import Vue from 'vue'
import Vuex from 'vuex'
import VueCompositionAPI from '@vue/composition-api'
import Vue2TouchEvents from 'vue2-touch-events'
import ContentSliderWidget from './components/ContentSliderWidget.vue'

import {WidgetState, WidgetType} from './models/store-state'
import actions from './store/actions'
import mutations from './store/mutations'
import getters from './store/getters'
import {root} from '@/shared/store'

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)
Vue.use(Vue2TouchEvents)

let widget = document.querySelectorAll('widget-content-slider')
if (widget.length) {
    widget.forEach(el => {
        let store = new Vuex.Store({
            state: new WidgetState,
            actions: actions,
            mutations: mutations,
            getters: getters,
            modules: {
                root
            }
        })

        new Vue({
            el: el,
            store,
            render(h: any) {
                let type = this.$el.attributes.getNamedItem('type')
                let dismissible = this.$el.attributes.getNamedItem('canHide')
                let slides = this.$el.attributes.getNamedItem('slides')
                let organisation = this.$el.attributes.getNamedItem('organisation')
                let consentHtml = this.$el.innerHTML
                let imageFallback = this.$el.attributes.getNamedItem('image-fallback');

                let widgetType: WidgetType = type ? (<any>WidgetType)[type.value] : null

                return h(ContentSliderWidget, {
                    props: {
                        config: {
                            type: widgetType ?? WidgetType.Single,
                            dismissible: dismissible ? dismissible.value.toLowerCase() === "true" : false,
                            slides: slides ? JSON.parse(slides.value) : null,
                            organisation: organisation?.value ?? 'VU',
                            consentHtml: consentHtml,
                            imageFallback: imageFallback?.value ?? 'vulogo'
                        }
                    }
                })
            }
        })
    })
}
